module.exports = __webpack_public_path__ + "img/companylogo.8c737015.svg";